<template>
  <div class="greeting-container">
    <div class="title">我为全面小康助力加油</div>
    <div class="look-text">查看我获得的“小康礼物”</div>

    <div class="dialog-inner">
      <div class="dialog-inner-2 nice-scroll">
        <img
          class="dialog-img"
          :src="g"
          alt=""
          v-for="(g, i) in giftDetailList.filter((d, i) => has(i))"
          :key="i"
        />
      </div>
    </div>

    <div class="percent-container">
      <div class="label">我的助力值</div>
      <div class="percent-inner">
        <div class="percent-bg">
          <div
            class="percent-bar"
            :style="{ width: `${(hasGiftList.length * 100) / 18}%` }"
          ></div>
        </div>
      </div>
    </div>

    <div class="icons-container">
      <img
        src="https://jcdn.xhby.net/project/xiaokang/assets/greeting/back.png"
        alt=""
        @click="goToDetail"
      />
      <div>
        已有 <span class="red">{{ greetedNumber }} </span> 人助力成功!
      </div>
      <img
        src="https://jcdn.xhby.net/project/xiaokang/assets/greeting/next.png"
        alt=""
        @click="next"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    next: Function,
    goToDetail: Function,
  },

  data() {
    return {
      giftDetailList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (1).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (2).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (3).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (4).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (5).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (7).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (8).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (9).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (10).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (11).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (12).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (13).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (14).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (15).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (16).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (6).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (17).png",
        "https://jcdn.xhby.net/project/xiaokang/assets/detail/giftimg (18).png",
      ],

      greetedNumber: 0,
    };
  },
  mounted() {
    let now = +new Date();
    let duringTime = (now - 1609363738388) / 1000 / 60;
    this.greetedNumber = Math.floor(duringTime * 13);
    this.greetedNumber = Math.min(4392381, this.greetedNumber);
  },
  computed: {
    hasGiftList() {
      return this.$store.state.hasGiftList;
    },
  },
  methods: {
    has(i) {
      return this.$store.state.hasGiftList.includes(i);
    },

    add(i) {
      if (this.has(i)) return;
      this.$store.commit("addHasGiftList", i);
    },
  },
};
</script>

<style scoped lang="less">
.greeting-container {
  width: 100vw;
  height: 100vh;
  background-image: url("https://jcdn.xhby.net/project/xiaokang/assets/welcome/bg0.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 30px;
  overflow: hidden;

  .title {
    font-size: 34px;
    margin-bottom: 20px;
    font-weight: 700;
    color: #c2343a;
  }

  .look-text {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .dialog-inner {
    width: 75vw;
    height: 35vh;
    border: 10px solid #ffeccb;
    background: white;
    position: relative;
    margin-top: 10px;
    overflow: hidden;

    .dialog-inner-2 {
      height: 100%;
      border: 1px dashed #c56f6f;
      display: flex;
      align-items: center;
      overflow: auto;

      .dialog-img {
        height: 80%;
        margin: 0 10px;
      }
    }
  }

  .percent-container {
    width: 75vw;
    margin-top: 20px;
    display: flex;
    padding: 0 20px;
    display: flex;
    align-items: center;

    .label {
      width: 100px;
    }

    .percent-inner {
      flex: 1;
      border: 10px solid #ffeccb;
      border-radius: 40px;

      .percent-bg {
        width: 100%;
        height: 12px;
        background: #f0b9b6;
        border-radius: 40px;

        .percent-bar {
          border-radius: 40px;
          height: 100%;
          background: #cc3c41;
        }
      }
    }
  }

  .icons-container {
    width: 100%;
    margin-top: 10px;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 100px;
      cursor: pointer;
    }
  }
}

.red {
  color: #c3363b;
}
</style>